export default "__VITE_ASSET__CBU0FSb9__"